module.exports = __webpack_public_path__ + "static/media/affirm.b52cf05b.png";